import React, { useEffect, useState } from "react";
import ClubsHeader from "../../components/clubs/ClubsHeader";
import { useParams, useSearchParams } from "react-router-dom";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import { useSelector } from "react-redux";
import {
  useGetAllPlayersQuery,
  useGetAllMembershipsQuery,
  useGetAllClubPaidPackagesQuery,
  useGetAllWalletUsersQuery,
  useAllPlayerVouchersQuery,
} from "../../lib/redux/services/sections/Customers";
import useCalender from "../../hooks/useCalender";
import CustomersHeader from "../../components/customers/CustomersHeader";
import SkeletonTable from "../../components/skeletons/SkeletonTable";
import ClubsTableSection from "../../components/clubs/ClubsTableSection";
import { coulmnsType } from "../../types";
import { useDebounce } from "../../hooks/useDebounce";
import Pagination from "../../components/global/Pagination";
import RowsPerPageSelect from "../../components/global/RowsPerPageSelect";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import CustomersContent from "./CustomerContent";
import MembershipContent from "./MembershipContent";
import PackegesContent from "./PackegesContent";
import ErrorSection from "../../components/global/ErrorSection";
import WalletContent from "./WalletContent";
import WalletHeader from "../../components/wallet/WalletHeader";
import WalletUsersTable from "../../components/wallet/WalletUsersTable";
import WalletUsersContent from "../../components/wallet/WalletUsersContent";
import CustomerVouchersContent from "../../components/wallet/CustomerVouchersContent";
import CustomerVouchers from "../../components/wallet/CustomerVouchers";

function CustomerAllVouchersPage() {
  const { customers, inputs, pricing }: DictionaryType = useGetDictionary();
  const playersColumns: coulmnsType = [
    {
      title: inputs.name,
      tag: "name",
    },
    {
      title: inputs.email,
      tag: "email_address",
    },
    {
      title: inputs.phone_number,
      tag: "mobile_number",
    },
    {
      title: inputs.gender,
      tag: "gender",
    },

    {
      title: inputs.level,
      tag: "level",
    },
    {
      title: customers.memberships,
      tag: "memberships",
    },
    {
      title: "",
      tag: "controll",
    },
  ];

  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const handleRowsChange = (value: number) => {
    setLimit(value);
  };
  const [filter, setFilter] = useState({});
//@ts-ignore
  const [voucherType, setVoucherType] = useState<"public" | "private">("private");
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const [page, setPage] = useState<"players" | "memberships"|'packages'|'Vouchers'>("players");
  const [data, setData] = useState<any>([]);
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    if (searchParams.get("section") === "membership") {
      setPage("memberships");
    }
  }, [searchParams]);

  const { currentDay, currentMonth, currentYear, getMonthName } = useCalender();
  const {id} = useParams();

  const [date, setDate] = useState({
    day: currentDay.index,
    month: currentMonth.index,
    year: currentYear,
  });
  
 


  return (
    <section className="w-full flex flex-col gap-4 overflow-hidden min-h-[600px] ">
      <CustomerVouchers
        data={data}
        updateDate={setDate}
        date={date}
        playerId={+id!}
        id={clubId}
        page={page}
        setSearch={setSearch}
        filter={filter}
        voucherType={voucherType}
        search={search}
        getFunction={useAllPlayerVouchersQuery}
        setPage={setPage}
        setFilter={setFilter}
        setCurrentPage={setCurrentPage}
      />
      {/* table section */}
      {<CustomerVouchersContent page={'customerVouchers'} filter={filter} search={search} setVoucherType={setVoucherType} />}
     

    </section>
  );
}

export default CustomerAllVouchersPage;
